<template>
  <div class="z-card pb-0 border-0">
    <div class="d-flex justify-content-between">
      <h4 class="z-card__title">{{ $t('stats.statistics.general.block.main') }}</h4>
      <div class="filter--time">
        <span v-for="hour in hours" :key="hour">
          {{ hour }} {{ $t('monitoring.short_hour') }}
        </span>
      </div>
    </div>

    <div class="z-card__body z-card__body--calls d-flex" style="position: relative">
      <div class="circle-row circle-evenly col-6 circle--box">
        <div class="circle-row__item circle-row__item--green">
          <span>{{ $t('monitoring.call.status.answered') }}</span>
          <span>{{ total.answer | format }}</span>
        </div>

        <div class="circle-row__item circle-row__item--blue">
          <span>{{ $t('monitoring.call.status.not_answered') }}</span>
          <span>{{ total.not_answer | format }}</span>
        </div>

        <template v-if="total.total">
          <stat-total-circle :data="circle_total" :colors="circle_colors">
            <span slot="title">{{ $t('monitoring.field.total') }}</span>
            <span slot="amount">{{ total.total | format }}</span>
          </stat-total-circle>
        </template>
        <template v-else>
          <div class="circle-row__item circle-row__item--grey">
            <span>{{ $t('monitoring.field.total') }}</span>
            <span>{{ total.total | format }}</span>
          </div>
        </template>
      </div>

      <div class="col ml-5 circle-row circle-evenly circle--box">
        <div class="circle-row__item call__item">
          <span>{{ $t('monitoring.call.status.average_duration') }}</span>
          <span>{{ total.average_duration | time }}</span>
        </div>
      </div>
      <div class="col ml-5 circle-row circle-evenly circle--box">
        <div class="circle-row__item call__item">
          <span>{{ $t('monitoring.call.status.max_duration') }}</span>
          <span>{{ total.max_duration | time }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import { mapGetters } from 'vuex';
  import { green, blue, yellow, red, purple } from '@shared/helpers/css';
  import StatTotalCircle from '@shared/components/stats-chart-cicle-total';
  import { seconds_to_time } from '@shared/helpers/time';
  // import { DATA } from '@/plugins/vuex-async-pagginate';

  export default {
    components: {
      StatTotalCircle
    },

    filters: {
      format: function (val) {
        return parseInt(val).toLocaleString();
      },
      time(val) {
        return seconds_to_time(val);
      }
    },
    data: () => ({
      hours: [1, 8, 12, 24]
    }),
    created() {},

    computed: {
      // ...mapGetters('monitoring/calls/table/successResponse', ['data'] ),
      items() {
        return this.$store.getters['monitoring/calls/table/successResponse'].data;
      },
      chart_options() {
        return {
          series: {
            0: { color: green },
            1: { color: blue },
            2: { color: yellow },
            3: { color: red },
            4: { color: purple }
          }
        };
      },
      columns() {
        return [
          '',
          this.$t('voice.call.status.answered'),
          this.$t('voice.call.status.busy'),
          this.$t('voice.call.status.no_answer'),
          this.$t('voice.call.status.failed')
        ];
      },

      chart_data() {
        const values = this.items.map((i) => [
          i['anwer_count'],
          i['not_anwer_count'],
          i['not_anwer_count'],
          i['average_duration'],
          i['max_duration'],
          i['total_duration']
        ]);

        return [this.columns, ...values];
      },

      total: function () {
        return {
          answer: this.items ? this.items.answer_count : '0',
          not_answer: this.items ? this.items.not_answer_count : 0,
          average_duration: this.items ? this.items.average_duration : '0',
          max_duration: this.items ? this.items.max_duration : '0',
          total_duration: this.items ? this.items.total_duration : '0',
          total: this.items ? this.items.total_count : '0'
        };
      },

      circle_total: function () {
        return [
          ['', ''],
          ['', this.total.not_active],
          ['', this.total.active],
          ['', this.total.call],
          ['', this.total.task]
        ];
      },

      circle_colors: function () {
        return [green, blue, yellow, red];
      }
    }
  };
</script>

<style lang="scss">
  .circle--box {
    padding: 30px;
    margin: 0;
  }
  .call__item {
    width: 150px;
    height: auto;
    span {
      font-size: 18px;
      max-width: 200px;
      margin-top: 10px;
      height: auto;
    }
  }
  .filter--time {
    display: flex;
    width: 140px;
    justify-content: space-between;
  }
</style>
